import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import SupportTickets from "../client/Support/SupportTickets";
import AdminSupportTickets from "../admin/Support/AdminSupportTickets";
import RequestMessages from "../../components/communication/RequestMessages";
import "./CommunicationCenter.css";

const CommunicationCenter = () => {
  const { user } = useAuth();
  const [searchParams] = useSearchParams();
  const isAdmin = String(user?.Role || "").toLowerCase() === "admin";
  const Tickets = isAdmin ? AdminSupportTickets : SupportTickets;
  const requestId = searchParams.get("requestId");
  const [activeTab, setActiveTab] = useState(requestId ? "requests" : "support");

  useEffect(() => {
    if (requestId) setActiveTab("requests");
  }, [requestId]);

  return (
    <main className="communication-center">
      <nav className="communication-center-tabs" aria-label="Communication types">
        <button
          type="button"
          className={activeTab === "support" ? "active" : ""}
          aria-current={activeTab === "support" ? "page" : undefined}
          onClick={() => setActiveTab("support")}
        >
          Support conversations
        </button>
        <button
          type="button"
          className={activeTab === "requests" ? "active" : ""}
          aria-current={activeTab === "requests" ? "page" : undefined}
          onClick={() => setActiveTab("requests")}
        >
          Store request messages
        </button>
      </nav>
      <section className="communication-center-messages">
        {activeTab === "support" ? <Tickets /> : <RequestMessages isAdmin={isAdmin} />}
      </section>
    </main>
  );
};

export default CommunicationCenter;
